// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1JIX7","title":"Info_title__2AqCN","links":"Info_links__ZVox7","link":"Info_link__3qMZf","logo":"Info_logo__z7KaW"};